<template>
	<div class="animated fadeIn">
		<AccountDetailComponent
			v-bind:accountSelected="accountSelected"
			v-bind:loading="loading">
		</AccountDetailComponent>

		<b-row>
			<b-col md="12">
				<b-card>
					<template v-slot:header>
						<b-row>
							<b-col md="6">
								Factura #<strong v-if="invoice">{{invoice.Number}}</strong>
							</b-col>
							<b-col md="6" class="d-flex justify-content-end">
								<div v-if="loading" class="ml-2">
									<b-spinner variant="primary" label="Spinning" small></b-spinner>
								</div>
								<div v-if="!loading && invoice && invoice.PDFUrl" class="ml-2">
									<b-button
										variant="link"
										@click="downloadFile(invoice.PDFUrl)"
										v-b-tooltip.hover
										class="text-danger p-0"
										title="Descargar Factura PDF">
										<i class="fa fa-file-pdf-o fa-2x" aria-hidden="true"></i>
									</b-button>
								</div>
								<div v-if="!loading && invoice && invoice.XMLUrl" class="ml-2">
									<b-button
										variant="link"
										@click="downloadFile(invoice.XMLUrl)"
										v-b-tooltip.hover
										class="text-info p-0"
										title="Descargar Documento XML">
										<i class="fa fa-file-code-o fa-2x" aria-hidden="true"></i>
									</b-button>
								</div>
								<div v-if="!loading && invoice && invoice.XMLResponseUrl" class="ml-2">
									<b-button
										variant="link"
										@click="downloadFile(invoice.XMLResponseUrl)"
										v-b-tooltip.hover
										class="text-black-50 p-0"
										title="Descargar Documento de Respuesta XML">
										<i class="fa fa-file-code-o fa-2x" aria-hidden="true"></i>
									</b-button>
								</div>
							</b-col>
						</b-row>
					</template>
					<b-card-body>
						<b-row>
							<b-col md="4" lg="3">
								<h6><span class="text-info">Fecha: </span> {{invoice.Date|dateFormatFull}}
								</h6>
							</b-col>

							<b-col md="4" lg="3" v-if="invoice.PaymentCondition">
								<h6><span class="text-info">Condición de Pago: </span> {{invoice.PaymentCondition}}
								</h6>
							</b-col>

							<b-col v-if="invoice && invoice.Key" md="4" lg="3">
								<h6><span class="text-info">Clave Electrónica: </span> {{invoice.Key}}
								</h6>
							</b-col>

							<b-col md="4" lg="3">
								<h6><span class="text-info">Compañia: </span> {{invoice.Company}}
								</h6>
							</b-col>

							<b-col md="4" lg="3" v-if="invoice.IncidentNumber">
								<h6><span class="text-info"># Caso: </span> {{invoice.IncidentNumber}}
								</h6>
							</b-col>

							<b-col md="4" lg="3" v-if="invoice.Incident">
								<h6><span class="text-info">Caso: </span> {{invoice.Incident}}
								</h6>
							</b-col>
						</b-row>
						<b-row class="mt-5">
							<b-col md="12" lg="12" class="table-responsive">
								<b-table :items="invoice.InvoiceProducts"
										 :fields="tableFields"
										 :busy="loading"
										 show-empty
										 striped
										 empty-filtered-text="No hay productos disponibles"
										 empty-text="No hay productos disponibles">
									<div slot="UnitPrice" slot-scope="item">
										{{currencySymbol}}{{item.item.UnitPrice|formatPrice}}
									</div>

									<div slot="Discount" slot-scope="item">
										{{currencySymbol}}{{item.item.Discount|formatPrice}}
									</div>

									<div slot="Taxes" slot-scope="item">
										{{currencySymbol}}{{item.item.Taxes|formatPrice}}
									</div>

									<div slot="Total" slot-scope="item">
										{{currencySymbol}}{{item.item.Total|formatPrice}}
									</div>
								</b-table>
							</b-col>
						</b-row>
						<b-row>
							<b-col md="6" lg="6" class="d-flex flex-column">
								<strong>Observaciones:</strong>
								<p>{{invoice.Description}}</p>
							</b-col>
							<b-col md="6" lg="6" class="d-flex flex-column">
								<b-row>
									<b-col md="6" lg="6" sm="6" cols="6" class="text-right">
										<strong>Sub Total</strong>
									</b-col>
									<b-col md="6" lg="6" sm="6" cols="6" class="text-right">
										{{currencySymbol}}{{invoice.SubTotal|formatPrice}}
									</b-col>
								</b-row>

								<b-row>
									<b-col md="6" lg="6" sm="6" cols="6" class="text-right">
										<strong>Descuento</strong>
									</b-col>
									<b-col md="6" lg="6" sm="6" cols="6" class="text-right">
										{{currencySymbol}}{{invoice.TotalDiscount|formatPrice}}
									</b-col>
								</b-row>

								<b-row>
									<b-col md="6" lg="6" sm="6" cols="6" class="text-right">
										<strong>Total Impuestos</strong>
									</b-col>
									<b-col md="6" lg="6" sm="6" cols="6" class="text-right">
										{{currencySymbol}}{{invoice.TotalTaxes|formatPrice}}
									</b-col>
								</b-row>

								<b-row>
									<b-col md="6" lg="6" sm="6" cols="6" class="text-right">
										<strong>Total</strong>
									</b-col>
									<b-col md="6" lg="6" sm="6" cols="6" class="text-right">
										<strong>{{currencySymbol}}{{invoice.Total|formatPrice}}</strong>
									</b-col>
								</b-row>

								<b-row>
									<b-col md="6" lg="6" sm="6" cols="6" class="text-right">
										<strong>Saldo</strong>
									</b-col>
									<b-col md="6" lg="6" sm="6" cols="6" class="text-right">
										{{currencySymbol}}{{invoice.Balance|formatPrice}}
									</b-col>
								</b-row>
							</b-col>
						</b-row>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>
		<GoBackComponent></GoBackComponent>
	</div>
</template>

<script>
	import AccountDetailComponent from '../components/AccountDetailComponent';
	import GoBackComponent from "../components/GoBackComponent";
	import {mapState} from "vuex";

	export default {
		name: "InvoiceDetail",
		components: {
			AccountDetailComponent,
			GoBackComponent,
		},
		data: function () {
			return {
				loading: false,
				invoice: '',
				tableFields: {
					Name: {
						label: 'Nombre del Producto'
					},
					UnitPrice: {
						label: 'Precio Unitario'
					},
					Qty: {
						label: 'Cantidad'
					},
					Discount: {
						label: 'Descuento'
					},
					Taxes: {
						label: 'Impuestos'
					},
					Total: {
						label: 'Total'
					}
				},
				currencySymbol: ''
			}
		},
		mounted() {
			this.loading = true;
			const invoiceId = this.$route.params.id;

			if (this.accountSelected !== '') {
				this.$store.dispatch('getInvoiceDetail', invoiceId)
					.then((invoice) => {
						this.invoice = invoice;
						if (invoice.Currency) {
							this.currencySymbol = invoice.Currency.Symbol
						}
					})
					.catch((error) => {
						console.log(error);
						this.loading = false;
					})
					.finally(() => {
						this.loading = false;
					})
			} else {
				this.$router.push('/accounts/');
			}
		},
		methods: {
			downloadFile(filePath) {
				this.loading = true;
				this.$store.dispatch('downloadInvoiceFile', filePath)
					.then((file) => {
						console.log(file);
						var fileURL = window.URL.createObjectURL(new Blob([file]));
						var fileLink = document.createElement('a');

						fileLink.href = fileURL;
						fileLink.setAttribute('download', filePath);
						document.body.appendChild(fileLink);

						fileLink.click();
						this.loading = false;
					})
					.finally(() => {
						this.loading = false;
					});
			}
		},
		computed: {
			...mapState({
				accountSelected: state => state.accountSelected
			})
		}
	}
</script>

<style scoped>

</style>
